import EntityValidationResult from 'modules/base/dto/validation/EntityValidationResult';
import CaptchaToGenerateEditDto from 'app/admin/captchatogenerate/dto/CaptchaToGenerateEditDto';
import nBossConnection from 'modules/base/service/nBossConnection';
import NamedDto from 'modules/base/dto/NamedDto';

class CaptchaToGenerateEditService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'captchaToGenerateEditControl';
	}

	/**
	 * @return {Promise<CaptchaToGenerateEditDto>}
	 */
	create() {
		return new Promise((resolve, reject) => {
			this.connection
				.get(`/${this.CONTROL}/create`)
				.then(response => resolve(new CaptchaToGenerateEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @return {Promise<CaptchaToGenerateEditDto>}
	 */
	getData(id) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/getData`, {
					id
				})
				.then(response => resolve(new CaptchaToGenerateEditDto().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {CaptchaToGenerateEditDto} dto
	 * @return {Promise<EntityValidationResult>}
	 */
	save(dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/save`, {
					dto
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {number} id
	 * @param {CaptchaToGenerateEditDto} dto
	 * @return {Promise<EntityValidationResult>}
	 */
	update(id, dto) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/update`, {
					id,
					dto
				})
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}
}

export default new CaptchaToGenerateEditService();
